// Service Contracts — service_contracts.* (Properties & Units)
//
// Backend keys are registered by the amer-laravel migration
// 2026_08_23_000004_add_service_contract_permissions. The ids below are the
// central-assigned approval numbers, all confirmed against the central
// permission-key registry on 2026-08-24 (approved 2026-08-23).
//
// These are not free to choose: an id here that does not equal its backend
// `permissions.id` fails silently — HAS_PERMISSION just returns false, so the
// page, the sidebar leaf and every gated button simply never appear, with no
// error anywhere. Re-confirm against the registry rather than inferring the next
// number if a key is ever re-registered.

/** service_contracts.index */
export const SERVICE_CONTRACTS_INDEX = 1468;
/** service_contracts.show — collapsed into index by the August 2026 audit. */
// Aliased rather than left on the deleted id 1469: a constant pointing at a key
// that no longer exists makes HAS_PERMISSION() false forever and the detail view
// vanishes for everyone. Whoever can list the register can open a row in it.
export const SERVICE_CONTRACTS_SHOW = SERVICE_CONTRACTS_INDEX;
/** service_contracts.create */
export const SERVICE_CONTRACTS_CREATE = 1470;
/** service_contracts.update */
export const SERVICE_CONTRACTS_UPDATE = 1471;
/** service_contracts.print */
export const SERVICE_CONTRACTS_PRINT = 1472;
/**
 * service_contracts.publish — turns a draft into a billing contract.
 *
 * Its own key rather than a reuse of `.update`, matching contracts.publish and
 * sell_contracts.publish: preparing a draft and committing one to raise dues
 * against a customer are different authorities. Approval number confirmed against
 * the central registry (1500), not inferred — a wrong id here fails silently,
 * exactly as the header note above says.
 */
export const SERVICE_CONTRACTS_PUBLISH = 1500;
/** service_contracts.download — collapsed into print by the August 2026 audit. */
// Producing the document is one capability: download is gated by the print
// permission. Aliased, not left on the deleted id 1473, for the reason above.
export const SERVICE_CONTRACTS_DOWNLOAD = SERVICE_CONTRACTS_PRINT;
